(() => {
  const root=document.querySelector('.a4-dark');
  if(!root)return;
  const items=root.querySelectorAll('.a4-wrap,.a4-about,.a4-feature,.a4-cta,.a4-cats a,.a4-grid article,.a4-hero > div');
  items.forEach((el,i)=>{el.classList.add('a4-reveal');el.style.setProperty('--delay',Math.min(i%8,7)*70+'ms')});
  const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}}),{threshold:.12});
  items.forEach(el=>io.observe(el));
  root.querySelectorAll('.a4-img img').forEach(img=>{
    const card=img.closest('article');if(!card)return;
    card.addEventListener('pointermove',e=>{const r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;img.style.transform='scale(1.08) translate('+x*10+'px,'+y*10+'px)'});
    card.addEventListener('pointerleave',()=>img.style.transform='');
  });
  const hero=root.querySelector('.a4-hero');
  if(hero)window.addEventListener('scroll',()=>{hero.style.backgroundPosition='calc(50% + '+window.scrollY*.025+'px) calc(50% + '+window.scrollY*.06+'px)'},{passive:true});
  const menu=root.querySelector('.a4-menu');
  if(menu){
    const panel=document.createElement('div');
    panel.className='a4-mobile-menu';
    panel.innerHTML='<a href="/collections/all">SHOP ALL</a><a href="/collections/bil-mobil">BIL & MOBIL</a><a href="/collections/hem-smart">HEM & SMART</a><a href="/collections/kok-matlagning">KÖK & MATLAGNING</a><a href="/search">SÖK</a><a href="/account">KONTO</a>';
    root.querySelector('.a4-head').after(panel);
    menu.addEventListener('click',()=>panel.classList.toggle('is-open'));
  }
})();